import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {
  MaintenanceData,
  MaintenanceService,
} from '../services/maintenance.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanActivate {
  public ignoreMaintenance: boolean;

  constructor(
    private readonly router: Router,
    private readonly maintenanceService: MaintenanceService
  ) {
    this.ignoreMaintenance =
      Boolean(localStorage.getItem('ignore-maintenance'));
  }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    // make request
    return new Promise<boolean>((resolve) => {
      if (this.ignoreMaintenance) {
        resolve(true);
        return;
      }

      this.maintenanceService.getMaintenanceStatus().subscribe({
        next: ({ data }: { data: MaintenanceData }) => {
          if (data?.enable_web) {
            resolve(true);
          } else {
            void this.router.navigate(['maintenance']);
            resolve(false);
          }
        },
        error: (_error: HttpErrorResponse) => {
          void this.router.navigate(['maintenance']);
          resolve(false);
        },
      });
    });
  }
}
